import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Badge,
  Box,
  Button,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";

import { QuickShipmentsBrowser as ShipperQuickShipmentsBrowser } from "components/Shipper/components/QuickShipmentsBrowser";
import { ShipmentSearchByName } from "components/Shipper/components/ShipmentsFilter/components/ShipmentSearchByName";
import { EVOTRUX_FILTER_ACTIVE_INDICATOR } from "constants/index";

interface Props {
  shipments: ShipperCondensedShipment[];
  shipmentSelectionIsDisabled: boolean;
  handlePageSelected: (e: React.ChangeEvent<unknown>, value: number) => void;
  page: number;
  pages: number;
  shipmentCount: number;
  onFiltersClick?: VoidFunction;
  activeFiltersCount?: number;
  onCollapse?: VoidFunction;
}

export function ShipmentSideBar(props: Props) {
  const {
    shipments,
    shipmentSelectionIsDisabled,
    handlePageSelected,
    page,
    pages,
    shipmentCount,
    onFiltersClick,
    activeFiltersCount = 0,
    onCollapse,
  } = props;

  return (
    <Stack
      direction="column"
      sx={{
        backgroundColor: "white",
        border: "1px solid #E0E0E0",
        borderRadius: "8px",
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
        overflow: "hidden",
      }}
    >
      <Stack direction="column" spacing={2} p={2}>
        <Stack direction="row" alignItems="center" spacing={0.5}>
          {/* Collapse button sits top-left so open/close share the same click
           point as the collapsed CollapsedShipmentRail. */}
          {onCollapse && (
            <Tooltip title="Collapse shipment list" placement="right" arrow>
              <IconButton
                onClick={onCollapse}
                aria-label="Collapse shipment list"
                size="small"
                sx={{ color: "#666666", ml: -1 }}
              >
                <ChevronLeftIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
          )}
          <Typography variant="h6">
            My Shipments ({shipmentCount ?? "-"})
          </Typography>
        </Stack>
        <ShipmentSearchByName tabType="regular" sx={{ width: "100%" }} />
        {/* More Filters Button */}
        {onFiltersClick && (
          <Box sx={{ position: "relative" }}>
            <Button
              variant="outlined"
              onClick={onFiltersClick}
              fullWidth
              startIcon={<FilterListIcon />}
              sx={{ textTransform: "none" }}
            >
              More filters
            </Button>
            {activeFiltersCount > 0 && (
              <Badge
                badgeContent={activeFiltersCount}
                sx={{
                  position: "absolute",
                  top: -1,
                  right: -1,
                  "& .MuiBadge-badge": {
                    backgroundColor: EVOTRUX_FILTER_ACTIVE_INDICATOR,
                    color: "white",
                    fontSize: "0.75rem",
                    minWidth: "18px",
                    height: "18px",
                    borderRadius: "9px",
                  },
                }}
              />
            )}
          </Box>
        )}
      </Stack>
      <Divider />
      <ShipperQuickShipmentsBrowser
        shipments={shipments}
        shipmentSelectionIsDisabled={shipmentSelectionIsDisabled}
        page={page}
        pages={pages}
        handlePageSelected={handlePageSelected}
      />
    </Stack>
  );
}
